import { useMutation, UseMutationResult } from "@tanstack/react-query"
import ResponseError from "#/types/responseError"
import buildCarrotApiRetryPolicy from "#/utils/CarrotApiRetryPolicy"
import { carrotClient } from "#/utils/CarrotClient"

export interface RtxConsentPayload {
  optIn: boolean
}

export function useSubmitRtxConsent(): UseMutationResult<void, ResponseError, RtxConsentPayload> {
  return useMutation<void, ResponseError, RtxConsentPayload>(
    (payload: RtxConsentPayload) => {
      return carrotClient.submitRtxConsent(payload)
    },
    {
      retry: buildCarrotApiRetryPolicy(2)
    }
  )
}
